// ── Promise.withResolvers polyfill (spec-tro, guard'et) ──────────────────
// Skal stå FØR alle andre imports så pdfjs-dist (loaded via usePdfToImage)
// kan finde API'et på ældre runtimes (Chrome <119, Safari <17.4, Firefox <121,
// Node <22). Moderne browsere bruger native impl. Dækker generelt — ikke iOS-only.
if (typeof (Promise as unknown as { withResolvers?: unknown }).withResolvers !== 'function') {
  (Promise as unknown as { withResolvers: () => unknown }).withResolvers = function () {
    let resolve!: (v: unknown) => void;
    let reject!: (e: unknown) => void;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { mountPublicMailEntry } from "./features/admin-v2/integration/mountPublicMailEntry";
import { assertProject } from "./features/admin-v2/integration/assert-project";



// Build config owns the expected project. Ordinary modes retain the prod lock.
assertProject(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  import.meta.env.VITE_EXPECTED_SUPABASE_REF, import.meta.env.MODE === 'admin-v2-dev');

const element = document.getElementById("root")!;
// Public mailbox proofs must never import telemetry (which imports the client),
// the product, Auth or providers. Ordinary startup keeps its existing order.
if (!mountPublicMailEntry(element, import.meta.env.VITE_SUPABASE_URL)) void startProduct();

async function startProduct() {
// ── One-time cache bust after major update ──
// Bump this value whenever you want all users to get a fresh load.
const REQUIRED_VERSION = "2026-06-07-v1";
const CACHE_VERSION_KEY = "elplanen_cache_version";

(async () => {
  const stored = localStorage.getItem(CACHE_VERSION_KEY);
  if (stored !== REQUIRED_VERSION) {
    localStorage.setItem(CACHE_VERSION_KEY, REQUIRED_VERSION);
    // Clear Service Worker caches if any
    if ("caches" in window) {
      const names = await caches.keys();
      await Promise.all(names.map(n => caches.delete(n)));
    }
    // Unregister any service workers
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    }
    // Hard reload to bypass disk cache
    window.location.reload();
  }
})();

// Initialize global error handler for uncaught errors
// A blocked optional font must not prevent ordinary app startup.
await import("./index.css").catch(error => console.warn("Stylesheet import failed", error));
const { initGlobalErrorHandler } = await import("./utils/globalErrorHandler");
initGlobalErrorHandler();
const { default: App } = await import("./App.tsx");

createRoot(element).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

}
